import { __assign } from "tslib";
import format from 'date-fns/format';
import parse from 'date-fns/parse';
import { SearchMaskInputType, websiteActions } from 'ltur-state-engine';
import Vue from 'vue-ltur';
var Calendar = /** @class */ (function () {
    function Calendar() {
    }
    Calendar.toggleActiveSelector = function (searchMaskGroupType, searchMaskInput, departureDateActive, returnDateActive, isClosed) {
        if (isClosed === void 0) { isClosed = false; }
        if (!isClosed) {
            this.switchPrimaryColor(departureDateActive, returnDateActive, false, searchMaskGroupType, searchMaskInput);
            Vue.dispatch(websiteActions.changeCalendarInitFlow(searchMaskGroupType, true));
        }
        else if (!departureDateActive && !returnDateActive) {
            this.switchPrimaryColor(departureDateActive, returnDateActive, true, searchMaskGroupType, searchMaskInput);
        }
        if (searchMaskInput.confirmedValue.value.departureDateActive !== departureDateActive
            || searchMaskInput.confirmedValue.value.returnDateActive !== returnDateActive) {
            searchMaskInput.confirmedValue.value.departureDateActive =
                departureDateActive;
            searchMaskInput.confirmedValue.value.returnDateActive =
                returnDateActive;
            Vue.dispatch(websiteActions.changeActiveDate(searchMaskGroupType, searchMaskInput.confirmedValue.value.departureDateActive, searchMaskInput.confirmedValue.value.returnDateActive));
        }
    };
    Calendar.switchPrimaryColor = function (departureDateActive, returnDateActive, isClosed, searchMaskGroupType, searchMaskInput) {
        var className = 'u-color-primary';
        var departureDateSelector = document.getElementById('departureDate_Selector_' + searchMaskGroupType);
        var returnDateSelector = document.getElementById('returnDate_Selector_' + searchMaskGroupType);
        if (departureDateSelector !== null && returnDateSelector !== null) {
            if (!departureDateActive) {
                departureDateSelector.classList.remove(className);
            }
            else if (!departureDateSelector.classList.contains(className) && !isClosed) {
                departureDateSelector.classList.add(className);
                this.updateCalendarUI(searchMaskInput, searchMaskGroupType);
            }
            if (!returnDateActive) {
                returnDateSelector.classList.remove(className);
            }
            else if (!returnDateSelector.classList.contains(className)) {
                returnDateSelector.classList.add(className);
                this.updateCalendarUI(searchMaskInput, searchMaskGroupType);
            }
        }
    };
    Calendar.updateCalendarUI = function (searchMaskInput, searchMaskGroupType) {
        searchMaskInput.confirmedValue.uiValue = __assign(__assign({}, searchMaskInput.confirmedValue.uiValue), this.getTravelPeriodUIValue(searchMaskInput.confirmedValue.value.departureDate, searchMaskInput.confirmedValue.value.returnDate, searchMaskInput.confirmedValue.value.departureDateActive, searchMaskInput.confirmedValue.value.returnDateActive, searchMaskInput.confirmedValue.value.exactDuration));
        Vue.dispatch(websiteActions.changeCalendarUI(searchMaskGroupType, searchMaskInput.confirmedValue.uiValue));
    };
    Calendar.changeTravelPeriodValues = function (lturState, searchMaskGroupType, searchMaskInput, departureDate, departureDateActive, returnDate, returnDateActive, duration) {
        searchMaskInput.confirmedValue.value.departureDate = departureDate;
        searchMaskInput.confirmedValue.value.returnDate = returnDate;
        searchMaskInput.confirmedValue.value.duration = duration;
        var searchMaskRequest = {
            searchMaskGroupType: searchMaskGroupType,
            searchMaskInput: searchMaskInput,
            inputValueParam: searchMaskInput.confirmedValue
        };
        Vue.dispatch(websiteActions.setSearchMaskConfirmed(searchMaskRequest, lturState));
        Vue.dispatch(websiteActions.changeActiveDate(searchMaskGroupType, departureDateActive, returnDateActive));
    };
    Calendar.getDurationMinMax = function (durationValue) {
        var durationString = '' + durationValue;
        var durationMin = parseInt(durationString.substr(1, 2), 10);
        var durationMax = parseInt(durationString.substr(3, 2), 10);
        if (durationMax === 0) {
            durationMax = durationMin;
        }
        return {
            durationMax: durationMax,
            durationMin: durationMin
        };
    };
    Calendar.getTravelPeriodUIValue = function (departureDateParam, returnDateParam, departureDateActive, returnDateActive, exactDuration) {
        var departureDatePart = departureDateParam;
        var departureDateFullPart = departureDateParam;
        if (departureDateParam !== '') {
            departureDatePart = format(parse(departureDateParam), 'DD.MM.');
            departureDateFullPart = format(parse(departureDateParam), 'DD.MM.YY');
        }
        var returnDatePart = returnDateParam;
        var returnDateFullPart = returnDateParam;
        if (returnDateParam !== '') {
            returnDatePart = format(parse(returnDateParam), 'DD.MM.');
            returnDateFullPart = format(parse(returnDateParam), 'DD.MM.YY');
        }
        return {
            departureDate: departureDatePart,
            departureDateFull: departureDateFullPart,
            headline: Calendar.getHeadlineCalendar(departureDateActive, returnDateActive, exactDuration),
            returnDate: returnDatePart,
            returnDateFull: returnDateFullPart,
            textDate: '-',
            textDuration: '/'
        };
    };
    Calendar.changeTravelPeriodUIValue = function (searchMaskGroupType, travelPeriodUIValue) {
        Vue.dispatch(websiteActions.changeCalendarUI(searchMaskGroupType, travelPeriodUIValue));
    };
    Calendar.getTravelPeriodUIValueDuration = function (durations, value) {
        var index = durations.map(function (e) { return e.value; }).indexOf(value);
        if (index < 0) {
            index = 0;
        }
        return durations[index].name;
    };
    Calendar.getHeadlineCalendar = function (departureDateActive, returnDateActive, exactDuration) {
        if (departureDateActive || (!departureDateActive && !returnDateActive)) {
            if (!exactDuration) {
                return Vue.translate('travel_period_departure_date');
            }
            return Vue.translate('travel_period_departure_date_exact');
        }
        else {
            if (!exactDuration) {
                return Vue.translate('travel_period_return_date');
            }
            return Vue.translate('travel_period_return_date_exact');
        }
    };
    Calendar.getDurationValue = function (durationParam) {
        var duration = '1' + durationParam + durationParam;
        if (durationParam < 10) {
            duration = '10' + durationParam + '0' + durationParam;
        }
        return parseInt(duration, 10);
    };
    Calendar.getFromDurationValue = function (durationParam) {
        var duration = '1' + durationParam + '00';
        if (durationParam < 10) {
            duration = '10' + durationParam + '00';
        }
        if (durationParam === 1) {
            duration = '10' + durationParam + '01';
        }
        return parseInt(duration, 10);
    };
    Calendar.toggleCalendarSelector = function (classList, className, event, searchMaskGroupType, searchMaskGroup) {
        var travelPeriodInputValue = searchMaskGroup.inputs[SearchMaskInputType.TRAVEL_PERIOD].confirmedValue.value;
        var changed = false;
        if (!classList.contains(className) && !travelPeriodInputValue.departureDateActive &&
            !travelPeriodInputValue.returnDateActive) {
            changed = true;
            travelPeriodInputValue.departureDateActive = true;
            travelPeriodInputValue.returnDateActive = false;
        }
        if (!classList.contains(className) && !travelPeriodInputValue.returnDateActive) {
            classList.add(className);
            changed = true;
        }
        if (!classList.contains(className) && !travelPeriodInputValue.departureDateActive) {
            classList.add(className);
            changed = true;
        }
        var element = event.target;
        if (!changed && element.id !== 'departureDate_Selector_' + searchMaskGroupType &&
            element.id !== 'returnDate_Selector_' + searchMaskGroupType) {
            classList.toggle(className);
            travelPeriodInputValue.departureDateActive = false;
            travelPeriodInputValue.returnDateActive = false;
            travelPeriodInputValue.datePickerIsOpen = !travelPeriodInputValue.datePickerIsOpen;
            changed = true;
        }
        if (element.id === 'departureDate_Selector_' + searchMaskGroupType) {
            if (!travelPeriodInputValue.departureDateActive) {
                travelPeriodInputValue.departureDateActive = true;
                travelPeriodInputValue.returnDateActive = false;
                changed = true;
            }
        }
        if (element.id === 'returnDate_Selector_' + searchMaskGroupType) {
            if (!travelPeriodInputValue.returnDateActive) {
                travelPeriodInputValue.departureDateActive = false;
                travelPeriodInputValue.returnDateActive = true;
                changed = true;
            }
        }
        if (changed) {
            travelPeriodInputValue.datePickerIsOpen = classList.contains(className);
        }
        if (changed) {
            Calendar.toggleActiveSelector(searchMaskGroupType, searchMaskGroup.inputs[SearchMaskInputType.TRAVEL_PERIOD], travelPeriodInputValue.departureDateActive, travelPeriodInputValue.returnDateActive);
        }
    };
    Calendar.getOptions = function () {
        var daysShort = [];
        for (var indexDaysShort = 1; indexDaysShort < 8; indexDaysShort++) {
            daysShort.push(Vue.translate('weekday_short', indexDaysShort));
        }
        var monthNames = [];
        for (var indexMonthNames = 1; indexMonthNames < 13; indexMonthNames++) {
            monthNames.push(Vue.translate('months_name', indexMonthNames));
        }
        var ariaLabels = {
            chooseDate: function (date) { return date; },
            chooseStartDate: function (date) { return ''; },
            chooseEndDate: function (date) { return ''; },
            selectedDate: function (date) { return ''; },
            unavailableDate: function (date) { return ''; },
            previousMonth: '',
            nextMonth: '',
            closeDatepicker: '',
            openKeyboardShortcutsMenu: '',
            closeKeyboardShortcutsMenu: '',
        };
        var texts = {
            Apply: '',
            Cancel: '',
            keyboardShortcuts: ''
        };
        var colors = {
            selected: 'transparent',
            inRange: '#F4067E',
            selectedText: '#fff',
            text: '#000',
            inRangeBorder: '#F4067E',
            disabled: 'transparent',
            textDisabled: '#878787',
            hoveredInRange: '#F4067E'
        };
        return {
            ariaLabels: ariaLabels,
            colors: colors,
            daysShort: daysShort,
            monthNames: monthNames,
            texts: texts
        };
    };
    return Calendar;
}());
export default Calendar;
